export default __webpack_public_path__ + "static/media/screen1.d2d05682.png";